<template>
  <div>
    <!-- <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :showNeed="showNeed"
                :exportNeed="exportNeed"
                @addForm="addForm"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columngroups="fieldsgroup"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol lg="4">
            <CInput
              label="Video Title"
              invalid-feedback="Video title should be filled"
              required
              v-model="$v.videoForm.title.$model"
              :is-valid="!$v.videoForm.title.$invalid"
            />
          </CCol>
          <CCol lg="4">
            <CInput
              label="Video URL"
              invalid-feedback="The URL should be filled"
              required
              v-model="$v.videoForm.url.$model"
              :is-valid="!$v.videoForm.url.$invalid"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="4">
            <div class="form-group">
              <label for="show">Show</label>
              <model-select
                class="form-control"
                id="show"
                :options="ShowList"
                v-model="$v.videoForm.show.$model"
                :isError="$v.videoForm.show.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.videoForm.show.$invalid"
                class="invalid-feedback-custom"
              >
                Show should be filled.
              </div>
            </div>
          </CCol>
          <CCol lg="4">
            <CInput
              label="Order Number"
              invalid-feedback="Order number should be filled"
              required
              v-model="$v.videoForm.order.$model"
              :is-valid="!$v.videoForm.order.$invalid"
              type="text"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="4">
            <div class="form-group">
              <label for="show">Show On Page</label>
              <model-select
                class="form-control"
                id="show"
                :options="ShowPageList"
                v-model="$v.videoForm.page.$model"
                :isError="$v.videoForm.page.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.videoForm.page.$invalid"
                class="invalid-feedback-custom"
              >
                Show should be filled.
              </div>
            </div>
          </CCol>

          <CCol lg="4">
            <div class="form-group">
              <label for="show">Media</label>
              <model-select
                class="form-control"
                id="media"
                :options="MediaList"
                v-model="$v.videoForm.media.$model"
                :isError="$v.videoForm.media.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.videoForm.media.$invalid"
                class="invalid-feedback-custom"
              >
                Media should be filled.
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="9">
            <label for="description">Description</label>
            <quill-editor
              style="height: 200px; margin-bottom: 70px"
              :content="content"
              :options="editorOption"
              :disabled="isReadonly"
              v-model="$v.videoForm.description.$model"
              @change="onEditorChange($event)"
            >
            </quill-editor>
            <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.faqForm.description.$model"
                :is-valid="!$v.faqForm.description.$invalid"
              /> -->
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.videoForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "HomeVideo",
  components: { quillEditor, Loading, TableButton, JqxGrid },
  data() {
    return {
      title: "Home Video",
     
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "title", type: "string" },
          { name: "url", type: "string" },
          { name: "show_label", type: "string" },
          { name: "page_label", type: "string" },
          { name: "media_label", type: "string" },
          { name: "media", type: "string" },
          { name: "page", type: "string" },
          { name: "show", type: "string" },
          { name: "order", type: "string" },
          { name: "description", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,
       fieldsgroup: [
        {
          text: "Actions",
          align: "center",
          name: "ActionsGroup",
        },
      ],
      fields: [
        {
          datafield: "title",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Title",
        },
        {
          datafield: "url",
          columntype: "textbox",
          filtertype: "textbox",
          text: "URL",
        },
        {
          datafield: "show_label",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Show",
        },
        {
          datafield: "page_label",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Show On Page",
        },
        {
          datafield: "media_label",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Media",
        },
        {
          datafield: "order",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Order",
        },
        {
          datafield: "description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Description",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columngroup: "ActionsGroup",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            // let path = this.$route.path.split("/");

            // this.$router.push({
            //   path: path.hasOwnProperty("2")
            //     ? path[2] + "/detail/" + dataRecord.id
            //     : "detail/" + dataRecord.id,
            // });
            this.editForm(dataRecord);
          },
          
        },
        {
          text: "Remove",
          columngroup: "ActionsGroup",
          align: "center",
          name: "CopyAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Remove";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            if(dataRecord.show === '0') {
            this.removeData(dataRecord);
            } else {
              alert('Sorry you cannot remove video while still active');
            }
            //this.cloneProduct(dataRecord);
          },
        },
      ],

      productList: [],
      ShowList: [
        { value: "1", text: "Yes" },
        { value: "2", text: "No" },
      ],
       MediaList: [
        { value: "1", text: "Youtube" },
        { value: "2", text: "Tiktok" },
      ],
      ShowPageList: [
        { value: "1", text: "Home" },
        { value: "2", text: "Berbagi Untuk Indonesia" },
      ],
      issueList: [],
      userList: [],
      items: null,
      videoForm: tableInterfaces.video,
      isReadonly: false,
      isLoading: false,
      addButton: false,
      isEdit: false,
      content: "",
      editorOption: {}, // data quill

      visibilityShow: false,
      showNeed: false,
      exportNeed: false,
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    videoForm: {
      title: { required },
      url: { required },
      show: { required },
      order: { required },
      page: { required },
      media: {required},
      description: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getVideo();
      this.getDropdown();
    },
    getDropdown: function () {
      this.isLoading = true;
      this.axios
        .get("console/dropdown/dropdown-home-video")
        .then((response) => {
          // console.log(response)
          if (response.data.status === 2000) {
            this.ShowList = response.data.show;
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getVideo: function () {
      this.isLoading = true;
      this.items = null;
      this.axios
        .get("console/master/home_video/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isReadonly = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.isReadonly = null;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.videoForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.video) {
        tableInterfaces.video[i] = null;
      }
      this.videoForm = tableInterfaces.video;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/master/home_video/add", this.videoForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/home_video/update", this.videoForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    removeData: function (item) {
      if (confirm("Are you sure want to remove this news ?")) {
        this.isLoading = true;
        this.axios
          .delete("console/master/home_video/remove/"+item.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.videoForm.description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
